import { ListItemIcon } from "@mui/material";
import React from "react";

import type { SidebarMenuItemIconProps } from "./types";

// Personalizza questi colori
const ICON_COLOR = "#94a3b8"; // Colore icone (grigio medio)
const ICON_ACTIVE_COLOR = "#60a5fa"; // Colore icone selezionate (blu)

export const SidebarMenuItemIcon: React.FC<SidebarMenuItemIconProps> = ({
  Icon,
  collapsed,
  isSelected,
}) => {
  if (!Icon) return null;
  return (
    <ListItemIcon
      sx={{
        color: isSelected ? ICON_ACTIVE_COLOR : ICON_COLOR,
        minWidth: collapsed ? 0 : 36,
        mr: collapsed ? 0 : 2,
        fontSize: 26,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "color .2s",
      }}
    >
      <Icon fontSize="inherit" color="inherit" />
    </ListItemIcon>
  );
};
